import { useAuthContext } from 'contexts/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SuspenseLoader } from '../../../components';
import { extractClientId, isAdminRole } from '../../../utils';

export function HomePageRedirect() {
  const { auth, awsAuth } = useAuthContext();
  const nav = useNavigate();

  useEffect(() => {
    if (!awsAuth || !auth) {
      return;
    }

    if (isAdminRole(auth)) {
      nav('/visits/list');
    } else {
      const clientId = extractClientId(auth);
      if (clientId) {
        nav(`/clients/${clientId}/dashboard`);
      } else {
        console.log('>>');
        nav('/visits/list');
      }
    }
  }, [auth, awsAuth, nav]);

  return <SuspenseLoader />;
}
